module.exports = __webpack_public_path__ + "img/project_16.c80e53bc.png";